/* global axios */

import ApiClient from './ApiClient';

class PostSaleCaseTopicsAPI extends ApiClient {
  constructor() {
    super('post_sale_cases', { accountScoped: true });
  }

  topicsUrl(postSaleCaseId) {
    return `${this.url}/${postSaleCaseId}/topics`;
  }

  catalog(postSaleCaseId) {
    return axios.get(`${this.topicsUrl(postSaleCaseId)}/catalog`);
  }

  list(postSaleCaseId) {
    return axios.get(this.topicsUrl(postSaleCaseId));
  }

  create(postSaleCaseId, topicCode, attributes = {}) {
    return axios.post(this.topicsUrl(postSaleCaseId), {
      topic_code: topicCode,
      attributes,
    });
  }

  update(postSaleCaseId, cardId, topicCode, attributes = {}) {
    const { expected_version: expectedVersion, ...topicAttributes } =
      attributes;
    return axios.patch(`${this.topicsUrl(postSaleCaseId)}/${cardId}`, {
      topic_code: topicCode,
      attributes: topicAttributes,
      expected_version: expectedVersion,
    });
  }

  destroy(postSaleCaseId, cardId, expectedVersion) {
    return axios.delete(`${this.topicsUrl(postSaleCaseId)}/${cardId}`, {
      data: { expected_version: expectedVersion },
    });
  }
}

export default new PostSaleCaseTopicsAPI();
